import {
  composeSDKFactories,
  clickPropsSDKFactory,
  focusPropsSDKFactory,
  createElementPropsSDKFactory,
  disablePropsSDKFactory,
} from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';

import {
  stylableButtonSDKFactory,
  accessibilityPropsSDKFactory,
} from '../../StylableButton/corvid/StylableButton.corvid';

import type {
  ISearchButtonOwnSDKFactory,
  ISearchButtonProps,
  ISearchButtonSDK,
} from '../SearchButton.types';

export const searchButtonCorvidType = '$w.SearchButton';

const searchButtonSDKFactory: ISearchButtonOwnSDKFactory = () => {
  return {
    get type() {
      return searchButtonCorvidType;
    },
  };
};

const elementPropsSDKFactory = createElementPropsSDKFactory();

export const sdk = composeSDKFactories<ISearchButtonProps, ISearchButtonSDK>([
  elementPropsSDKFactory,
  clickPropsSDKFactory,
  focusPropsSDKFactory,
  disablePropsSDKFactory,
  accessibilityPropsSDKFactory,
  stylableButtonSDKFactory,
  searchButtonSDKFactory,
]);

export default createComponentSDKModel(sdk);
